import { supabase } from '../lib/supabase';

const notSignedIn = () => ({
  data: null,
  error: {
    message: 'Not signed in',
    context: new Response(JSON.stringify({ error: 'Please sign in again.', code: 'no_session' }), {
      status: 401,
      headers: { 'Content-Type': 'application/json' }
    })
  }
});

// Calls an Edge Function with the signed-in user's own access token.
// Refreshes the session first when it is missing or about to expire.
export const invokeAuthed = async (name, body) => {
  let { data: { session } } = await supabase.auth.getSession();
  const expiresSoon = session?.expires_at && session.expires_at * 1000 < Date.now() + 30000;
  if (!session || expiresSoon) {
    const { data, error } = await supabase.auth.refreshSession();
    session = error ? null : data?.session || null;
  }
  if (!session?.access_token) return notSignedIn();
  return supabase.functions.invoke(name, {
    body,
    headers: { Authorization: `Bearer ${session.access_token}` }
  });
};